import { redirectToUrl } from "~/utils/url/urlUtils";

export function sendLinearResetConfigurator(productCode: string): void {
  redirectToUrl(`/${productCode}/configuratorPage/reset`);
}
